'use client';

import { c as _c } from "react/compiler-runtime";
import { Fragment, useState } from 'react';
import { useFilters, useOverrides } from '../store';
import type { Flag } from '../types';
import css from './experiments.module.scss';
import { FeatureFlag } from './feature-flag';
import { Search } from './search';
interface Props {
  flags: Flag[];
}
export function Experiments(t0) {
  const $ = _c(18);
  const {
    flags
  } = t0;
  const [search, setSearch] = useState("");
  const {
    overrides,
    filter
  } = useOverrides();
  const {
    category
  } = useFilters();
  let t1;
  if ($[0] !== search) {
    t1 = <Search search={search} onSearch={setSearch} />;
    $[0] = search;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== category || $[3] !== filter || $[4] !== flags || $[5] !== overrides || $[6] !== search) {
    let t3;
    if ($[8] !== category || $[9] !== filter || $[10] !== overrides || $[11] !== search) {
      t3 = f => f.key.includes(search) && (!filter || f.key in overrides) && (category === "all" || f.category === category);
      $[8] = category;
      $[9] = filter;
      $[10] = overrides;
      $[11] = search;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t2 = flags.filter(t3).map(_temp);
    $[2] = category;
    $[3] = filter;
    $[4] = flags;
    $[5] = overrides;
    $[6] = search;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[13] !== t2) {
    t3 = <div className={css.list}>{t2}</div>;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== t1 || $[16] !== t3) {
    t4 = <div className={css.section}>{t1}{t3}</div>;
    $[15] = t1;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
function _temp(flag) {
  return <Fragment key={flag.key}><FeatureFlag flag={flag} /><div className={css.divider} /></Fragment>;
}